import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { identityServices } from '../identityServices'
import {
  SendPhoneVerificationCodePayload,
  SendPhoneVerificationCodeDTO,
} from '../identityTypes'
import { ApiErrorCode, ErrorDetail } from '@/api/apiTypes'
import { mapAxiosErrorToApiError } from '@/utils'

interface UseSendPhoneVerificationCodeOptions {
  onSuccess?: (data: SendPhoneVerificationCodeDTO) => void
  onError?: (error: { errorMessage?: string; code?: string }) => void
}

export const useSendPhoneVerificationCode = (
  options?: UseSendPhoneVerificationCodeOptions,
) => {
  const { t } = useTranslation()

  return useMutation<
    SendPhoneVerificationCodeDTO,
    ErrorDetail,
    SendPhoneVerificationCodePayload
  >({
    mutationFn: identityServices.sendPhoneVerificationCode,
    onSuccess: (data) => {
      options?.onSuccess?.(data)
    },
    onError: (err) => {
      const { code } = mapAxiosErrorToApiError(err)

      let errorMessage = t('api:errors.somethingWrong')

      if (code === ApiErrorCode.TOO_MANY_ATTEMPTS) {
        errorMessage = t('api:errors.manyAttempts')
      }

      if (code === ApiErrorCode.USER_ALREADY_EXISTS_ERROR) {
        errorMessage = t('api:phoneNumberAlreadyInUse')
      }

      options?.onError?.({
        errorMessage,
        code,
      })
    },
  })
}
